import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {DraftJobStopChange} from "../../../models/draft-job-stop-change.model";
import {DraftJobChangeField} from "../../../types/draft-job-change-field.enum";

require('./planning-draft-job-stop-change.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-job-stop-change',
  templateUrl: './planning-draft-job-stop-change.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobStopChangeComponent {
  @Input() stop: DraftJobStopChange;

  public readonly fields = DraftJobChangeField;

  isBlocked(field: DraftJobChangeField): boolean {
    return !!this.stop?.blockedFields?.includes(field);
  }
}
